import React, { FC, useEffect, useState } from 'react';
import { OverviewFilterType } from './types';
import BaseStats, { BaseStatsType } from 'components/base/stats-details';
import { apiService } from 'utils/api';
import useDashboardContext from 'contexts/dashboard.context';

type StatisticsTypes = {
  filters: OverviewFilterType;
};
const Statistics: FC<StatisticsTypes> = ({ filters }) => {
  const { activeCokitchen } = useDashboardContext();
  const [statisticsData, setStatisticsData] = useState<Omit<BaseStatsType, 'loading'>[]>([]);
  const [loading, setLoading] = useState(false);

  const getStatisticsData = async () => {
    if (!activeCokitchen?.id || !filters.activePolygon.id) return;
    setLoading(true);
    resetStatsData();
    const { startDate: start_date, endDate: end_date } = filters.dateRange.date;
    const cokitchen_id = activeCokitchen?.id;

    const data: any = {
      cokitchen_id,
      start_date,
      end_date
    };
    if (filters.activePolygon.id !== 'ALL') data.cokitchen_polygon_id = filters.activePolygon.id;
    const res = await apiService.post('logistics/logistics-data', {
      data,
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
    setStatisticsData([
      {
        title: 'DELIVERY REVENUE',
        type:
          res?.data?.delivery_revenue_prev > res?.data?.delivery_revenue ? 'decrease' : 'increase',
        weeklyVal: res?.data?.delivery_revenue_prev,
        value: res?.data?.delivery_revenue,
        withNaira: true
      },
      {
        title: 'TOTAL TRIPS',
        type: res?.data?.total_trips_prev > res?.data?.total_trips ? 'decrease' : 'increase',
        weeklyVal: res?.data?.total_trips_prev,
        value: res?.data?.total_trips
      },
      {
        title: 'AVG. TIME PER TRIP',
        type:
          res?.data?.average_time_per_trip > res?.data?.average_time_per_trip_prev
            ? 'decrease'
            : 'increase',
        weeklyVal: Math.round(res?.data?.average_time_per_trip_prev),
        value: String(Math.round(res?.data?.average_time_per_trip)),
        time: 'mins'
      },
      {
        title: filters.activePolygon.id !== 'ALL' ? 'VIEW RIDERS' : 'TOTAL RIDERS',
        type: 'online',
        weeklyVal: '',
        value: res?.data?.total_riders,
        route:
          filters.activePolygon.id !== 'ALL' ? `/polygon-riders/${filters.activePolygon.id}` : ''
      },
      {
        title: 'ONGOING TRIPS',
        type: 'online',
        value: res?.data?.total_ongoing_trips
      }
    ]);
    setLoading(false);
  };

  const resetStatsData = () => {
    setStatisticsData([
      {
        title: 'DELIVERY REVENUE',
        type: 'increase',
        weeklyVal: 0,
        value: '0',
        withNaira: true
      },
      {
        title: 'TOTAL TRIPS',
        type: 'increase',
        weeklyVal: 0,
        value: '0'
      },
      {
        title: 'AVG. TIME PER TRIP',
        type: 'increase',
        weeklyVal: 0,
        value: '0',
        time: 'mins'
      },
      {
        title: 'TOTAL RIDERS',
        type: 'increase',
        weeklyVal: 0,
        value: '0'
      },
      {
        title: 'ONGOING TRIPS',
        type: 'increase',
        weeklyVal: 0,
        value: '0'
      }
    ]);
  };
  useEffect(() => {
    getStatisticsData();
  }, [filters, activeCokitchen]);
  return (
    <div className='flex flex-col lg:flex-row gap-2 justify-between lg:items-start w-full bg-[#FFFCF5] p-4 rounded-[8px] border border-[#DEE1E3]'>
      {statisticsData.length === 0 && (
        <div className='leading-[130px] text-center w-full'>
          <p>Loading...</p>
        </div>
      )}
      {statisticsData?.map(({ title, type, time, value, weeklyVal, withNaira, route }, i) => (
        <div
          className={`lg:basis-[20%] flex justify-center ${
            statisticsData.length - 1 === i
              ? ''
              : 'border-b py-2 lg:border-r lg:border-b-0 border-gray-2'
          }`}
          key={i}>
          <BaseStats
            title={title}
            type={type}
            weeklyVal={weeklyVal}
            value={value}
            time={time}
            withNaira={withNaira}
            activeDateRange={filters.dateRange.range}
            loading={loading}
            route={route}
          />
        </div>
      ))}
    </div>
  );
};

export default Statistics;
